import api from '@/services/api';

export default {

    uploadImage(file, onUploadProgress) {
    
        let formData = new FormData();
    
        formData.append("image", file);
    
        return api.post("/api/image/", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          },
          onUploadProgress
        }).then(response => response.data);

    },

    voteImage(payload) {
        return api.post("/api/vote/add/", payload)
                .then(response => response.data);

    },

    updateImage(id, payload) {
        return api.put("/api/image/" + id + '/', payload)
                .then(response => response.data);
    },
    
    fetchImages(payload) {
        return api.get("/api/image/", {
            params: payload
          }).then(response => response.data);
    }

}

